var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "is-flex is-justify-content-space-between" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Emails")]),
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.emails.length < 2,
                expression: "emails.length < 2",
              },
            ],
            staticClass: "button is-small is-primary is-light",
            class: `is-light-btn-${_vm.$theme.name}`,
            attrs: { disabled: !_vm.$userInfo.isSystemAccount },
            on: { click: _vm.addTmpEmail },
          },
          [_vm._m(0)]
        ),
      ]),
      _vm._l(_vm.emails, function (assetEmail, index) {
        return _c("div", { key: index, staticClass: "field has-addons" }, [
          _c("div", { staticClass: "control" }, [
            _c("span", { staticClass: "select" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: assetEmail.type,
                      expression: "assetEmail.type",
                    },
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        content: "Duplicate Type",
                        theme: "danger",
                        enabled: !_vm.$v.uniqueEmailType,
                      },
                      expression:
                        "{ content: 'Duplicate Type', theme: 'danger', enabled: !$v.uniqueEmailType }",
                    },
                  ],
                  class: { "is-invalid": !_vm.$v.uniqueEmailType },
                  attrs: { disabled: !_vm.$userInfo.isSystemAccount },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        assetEmail,
                        "type",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                _vm._l(_vm.emailTypes, function (type, typeIndex) {
                  return _c(
                    "option",
                    {
                      key: typeIndex,
                      domProps: { value: type.toString() },
                      on: {
                        change: function ($event) {
                          return _vm.$v.emails.types.touch()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(typeIndex) + " ")]
                  )
                }),
                0
              ),
            ]),
          ]),
          _c("div", { staticClass: "control is-expanded" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: assetEmail.address,
                  expression: "assetEmail.address",
                },
              ],
              staticClass: "input",
              attrs: { type: "text", disabled: !_vm.$userInfo.isSystemAccount },
              domProps: { value: assetEmail.address },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(assetEmail, "address", $event.target.value)
                  },
                  function ($event) {
                    return _vm.$v.emails.$each[index].address.$touch()
                  },
                ],
              },
            }),
            !_vm.$v.emails.$each[index].address.required
              ? _c("span", { staticClass: "help is-danger" }, [
                  _vm._v("Email is required"),
                ])
              : _vm._e(),
            !_vm.$v.emails.$each[index].address.email
              ? _c("span", { staticClass: "help is-danger" }, [
                  _vm._v("Please enter a valid email"),
                ])
              : _vm._e(),
          ]),
          _c("p", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button has-text-gold",
                attrs: {
                  title: [assetEmail.isDefault ? "Default Email" : ""],
                  disabled:
                    !_vm.$userInfo.isSystemAccount ||
                    (_vm.emails.length == 1 && assetEmail.isDefault),
                },
                on: {
                  click: function ($event) {
                    return _vm.setDefault(assetEmail)
                  },
                },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c(
                    "span",
                    {
                      staticClass: "mso mso-24px",
                      class: [assetEmail.isDefault ? "mso-fill" : ""],
                    },
                    [_vm._v(" star ")]
                  ),
                ]),
              ]
            ),
          ]),
          _c("p", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button has-text-danger",
                attrs: {
                  disabled:
                    !_vm.$userInfo.isSystemAccount || assetEmail.isDefault,
                },
                on: {
                  click: function ($event) {
                    return _vm.removeEmail(assetEmail)
                  },
                },
              },
              [_vm._m(1, true)]
            ),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "mso mso-24px" }, [_vm._v(" add ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "mso mso-24px" }, [_vm._v(" remove ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }